/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
export * from "./Capabilities";
export * from "./RenderCompatibility";

/** @docs-package-description
 * The webgl-compatibility package provides APIs for determining the level of compatibility of a browser+device with the iTwin.js rendering system.
 */

/**
 * @docs-group-description Compatibility
 * APIs for evaluating compatibility with the iTwin.js rendering system.
 */
